import { IconButton } from '@airbus/components-react';
import SaveIcon from '@mui/icons-material/Save';

export default function SaveChangesIcon(props) {
  const { isRowLoading, shouldPreventLeaving, onClick, testId } = props;
  const isDisabled = isRowLoading || !shouldPreventLeaving;

  return (
    <IconButton
      variant='ghost'
      size='small'
      disabled={isDisabled}
      onClick={onClick}
      data-testid={testId}
    >
      <SaveIcon />
    </IconButton>
  );
}


